import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import GoogleMaps from "../components/GoogleMaps";
import ImageUploader from "../components/ImageUploader";
import Spinner from "../components/Spinner";
import LexicalEditor from "../components/text-editor/MyLexicalEditor";
import TimeSelect from "../components/TimeSelect";

export default function EditEventModal({
	show,
	onHide,
	event,
	formData,
	saving,
	onChange,
	onSave,
	onCancelEvent,
	onActivateEvent,
	onDeleteEvent,
	onCopyEvent,
	onImageChange,
	setFormData,
}) {
	return (
		<Modal show={show} onHide={onHide}>
			<Modal.Header closeButton>
				<Modal.Title>Edit Event</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<Form>
					<Form.Group className="mb-3">
						<ImageUploader
							label={event.imageUrl ? "Change Image" : "Event Image"}
							onImageChange={onImageChange}
							savedImage={event.imageUrl}
						/>
						<Form.Label>Title</Form.Label>
						<Form.Control name="title" value={formData.title} onChange={onChange} placeholder="Event Title" />
					</Form.Group>
					<Form.Group className="mb-3">
						<GoogleMaps eventData={formData} handleChange={onChange} setEventData={setFormData} />
					</Form.Group>

					<Form.Group className="mb-3">
						<Row>
							<Col className="mb-3 mb-md-0">
								<Form.Label>
									<i className="bi bi-calendar-event me-2"></i>Date
								</Form.Label>
								<Form.Control
									type="date"
									name="date"
									value={formData.date}
									onChange={onChange}
									style={{ cursor: "pointer" }}
									onClick={(e) => e.target.showPicker?.()}
								/>
							</Col>
							<Col>
								<Form.Label>
									<i className="bi bi-clock me-2"></i>Time
								</Form.Label>
								<div className="d-flex align-items-center gap-2">
									<TimeSelect
										name="startTime"
										value={formData.startTime || formData.time || ""}
										onChange={onChange}
										inline
									/>
									<span className="fw-semibold flex-shrink-0">to</span>
									<TimeSelect
										name="endTime"
										value={formData.endTime || ""}
										onChange={onChange}
										inline
										required={false}
									/>
								</div>
							</Col>
						</Row>
					</Form.Group>

					<Form.Group className="mb-3">
						<Form.Label>
							<i className="bi bi-info-circle me-2"></i>Details
						</Form.Label>
						<LexicalEditor
							initialValue={event.details}
							onChange={(val) => onChange({ target: { name: "details", value: val } })}
						/>
					</Form.Group>
				</Form>
			</Modal.Body>

			<Modal.Footer>
				<Button className="my-btn" onClick={onCopyEvent} disabled={saving}>
					<i className="bi bi-files me-1"></i> Copy Event
				</Button>

				{event.eventStatus === "active" && (
					<Button variant="warning" onClick={onCancelEvent} disabled={saving}>
						<i className="bi bi-x-octagon me-1"></i> Cancel Event
					</Button>
				)}

				{event.eventStatus === "canceled" && (
					<Button variant="info" onClick={onActivateEvent} disabled={saving} className="my-btn">
						<i className="bi bi-arrow-repeat me-1"></i> Activate Event
					</Button>
				)}

				<Button variant="danger" onClick={onDeleteEvent} disabled={saving}>
					<i className="bi bi-trash me-1"></i> Delete Event
				</Button>
			</Modal.Footer>

			<Modal.Footer>
				<Button variant="success" onClick={onSave} disabled={saving}>
					{saving ? <Spinner size="sm" /> : "Save Changes"}
				</Button>
				<Button variant="secondary" onClick={onHide} disabled={saving}>
					Close
				</Button>
			</Modal.Footer>
		</Modal>
	);
}
